var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#3299FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.875H5.3125C4.58763 8.875 4 9.46263 4 10.1875C4 10.9124 4.58763 11.5 5.3125 11.5H6.1875C6.91237 11.5 7.5 12.0876 7.5 12.8125C7.5 13.5374 6.91237 14.125 6.1875 14.125H4M5.75 8V8.875M5.75 14.125V15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 8.875H11.4375C10.7126 8.875 10.125 9.46263 10.125 10.1875C10.125 10.9124 10.7126 11.5 11.4375 11.5H12.3125C13.0374 11.5 13.625 12.0876 13.625 12.8125C13.625 13.5374 13.0374 14.125 12.3125 14.125H10.125M11.875 8V8.875M11.875 14.125V15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 8.875H17.5625C16.8376 8.875 16.25 9.46263 16.25 10.1875C16.25 10.9124 16.8376 11.5 17.5625 11.5H18.4375C19.1624 11.5 19.75 12.0876 19.75 12.8125C19.75 13.5374 19.1624 14.125 18.4375 14.125H16.25M18 8V8.875M18 14.125V15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group$$.461fe25c321e15a4f964c46acebde6a0.svg";
export { ForwardRef as ReactComponent };